import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SecurityLevel } from 'src/app/interfaces/security-level';
import { SecurityLevelsApiService } from 'src/app/services/security-levels-api.service';
import { MasterService } from 'src/app/services/master.service';
@Component({
  selector: 'add_module_dialog',
  templateUrl: './add_module_dialog.component.html',
  styleUrls: ['./add_module_dialog.component.css'],
})
export class ModuleAddDialogComponent implements OnInit {
  form: any;
  description: string;
  selectedFile: File | null = null;
  resultMessage : string = '';
  uploadProgress: number = 0;
  isUploading: boolean = false;
  security_levels: SecurityLevel[] = [];
  short_title: string = '';
  security_level: SecurityLevel = { ID: -1, ShortTitle: '' };
  commandline: string = '';
  inputparametrs: string = '';
  
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModuleAddDialogComponent>,
    private security_levels_api: SecurityLevelsApiService,
    private modules_api: MasterService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.description = data.description;
  }

  ngOnInit() {
    this.form = this.fb.group({
      short_title: [this.short_title, []],
      description: [this.description, []],
      security_level: [this.security_level, []],
      commandline: [this.commandline, []],
      inputparametrs: [this.inputparametrs, []],
    });
    this.security_levels_api.getSecurityLevels().subscribe((res) => {
      this.security_levels = res;
    });
    this.dialogRef.updateSize('80%', '100%');

  }

  save() {
    this.modules_api.Add_module(this.form?.value)?.subscribe((res) => {});
    this.dialogRef.close(this.form?.value);
  }
  
  file_upload(): void {
  
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    //fileInput.accept = '.py,.bin,.exe'; 
    fileInput.style.display = 'none';
  
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.uploadModuleFile(file);
      }
    };
    fileInput.click();
  }
  

  uploadModuleFile(file: File): void {
    this.isUploading = true;
    this.uploadProgress = 0;
    
    this.modules_api.Upload_module_file(file).subscribe({
      next: (response) => {
        //console.log('Файл загружен:', response);
        this.isUploading = false;
        //alert('Файл успешно загружен!');
        this.form.get('commandline')?.setValue("./"+file.name+' -inputCsv InFile.csv -outputCsv OutFile.csv');
        this.resultMessage='Файл успешно загружен!';
      },
      error: (error) => {
        console.error('Ошибка загрузки:', error);
        this.isUploading = false;
        this.resultMessage='Ошибка загрузки файла: '+ error.error?.error || error.message;
        //alert('Ошибка загрузки файла: ' + error.error?.error || error.message);
      }
    });
  }
  close() {
    this.dialogRef.close();
  }
}
